import ErrorFallback from 'Components/ErrorFallback'
import { isSuperuser } from 'Services/common/Features/User/userSlice'
import useTypedSelector from 'Store'
import { LOGIN_PAGE_PATH } from 'Util/constants'
import ProtectedRoute from 'Util/ProtectedRoute'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'
import {
  AffiliateNotificationDetailPage,
  AuthorityNotificationDetailPage,
  NotificationListPage,
  WebShopNotificationDetailPage
} from './Pages'

const NotificationRoot = () => {
  const { authed: isAuthed, user } = useTypedSelector(state => state.user)

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<NotificationListPage />} />
        <Route path={`webshop/create`} element={<WebShopNotificationDetailPage />} />
        <Route path={`webshop/:id`} element={<WebShopNotificationDetailPage />} />
        <Route path={`affiliate/:id`} element={<AffiliateNotificationDetailPage />} />
        <Route path={`affiliate/create`} element={<AffiliateNotificationDetailPage />} />
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={isAuthed}
              isAllowed={isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
          path={`authority/`}
        >
          <Route path={`:id`} element={<AuthorityNotificationDetailPage />} />
          <Route path={`create`} element={<AuthorityNotificationDetailPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}
export default NotificationRoot
